import { GraphQLObjectType, GraphQLNonNull } from 'graphql'
import { dateTimeType, DateTime } from './date-time-type'

export interface TimeWindow {
  readonly start: DateTime
  readonly end?: DateTime
}

export const TimeWindowType = new GraphQLObjectType({
  name: 'TimeWindow',
  description: 'Defines a start and end time for a window',
  fields: () => ({
    start: {
      description: 'The start date of the window',
      type: new GraphQLNonNull(dateTimeType)
    },
    end: {
      description: 'The end date of the window',
      type: dateTimeType
    }
  })
})
